import React, { useState, useMemo, useRef, useLayoutEffect, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { CommonAjaxGetRequestWithOutParamsWithOutAuthorization, CommonAjaxGetRequestWithOutParamsWithoutToken, CommonAjaxPdfADownloadlink } from "../Api/CommonAjaxUtils";
import { AWS_DOWNLOAD_URL_PO, FILE_DOWNLOAD_URL, FILE_DOWNLOAD_URL_PO, HRMS_API_BASE_URL, PO_2025_GOS } from "../Api/APIURLS";
import { Icon, FileIcon, SearchIcon, FilesIcon, GlobeIcon, BuildingIcon, UsersIcon, UploadIcon, LogoutIcon, InboxIcon, ChevRtIcon } from "./PresidentialOrderIcons";
import { useDispatch } from "react-redux";
import * as HERBUI from 'react-bootstrap';
/* ---------------- Seed repository ---------------- */


/* ---------------- Helpers ---------------- */
const capitalizeFirstLetter = (text) =>
    text ? text.charAt(0).toUpperCase() + text.slice(1) : "";
function esc(s) {
    return (s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function highlight(text, q) {
    const e = esc(text);
    if (!q) return e;
    const r = q.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    return e.replace(new RegExp(`(${r})`, "gi"), "<mark>$1</mark>");
}
function fmtDate(d) {
    if (!d) return "";
    return new Date(`${d}T00:00:00`).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}
function dparts(d) {
    if (!d) return { dd: "", dm: "", dy: "" };
    const dt = new Date(`${d}T00:00:00`);
    return {
        dd: String(dt.getDate()).padStart(2, "0"),
        dm: dt.toLocaleDateString("en-IN", { month: "short" }),
        dy: dt.getFullYear(),
    };
}

/* ---------------- Order card ---------------- */
function OrderCard({ order, q, index }) {
    const [showAllOrders, setShowAllOrders] = useState(false);
    
    const dp = dparts(order.goDate);
    const dispatch = useDispatch()
    const date = order.goDate?.split("/") || [];
    // const downloadAttachment = (file, name) => {
    //     let filedownload_url = FILE_DOWNLOAD_URL_PO + file
    //     getS3UrlDataPresidentialOrder(filedownload_url)
    //     // CommonAjaxPdfADownloadlink(filedownload_url, name, dispatch)
    // }
    // const getS3UrlDataPresidentialOrder = async (url) => {
    //     const resp = await CommonAjaxGetRequestWithOutParamsWithOutAuthorization(
    //         AWS_DOWNLOAD_URL_PO + url
    //     );
    //     return resp;
    // };

    const getS3UrlDataPresidentialOrder = async (url) => {
        const resp = await CommonAjaxGetRequestWithOutParamsWithOutAuthorization(
            url
        );
        // const resp = await CommonAjaxGetRequestWithOutParamsWithOutAuthorization(
        //     AWS_DOWNLOAD_URL_PO + url
        // );
        if (resp) {
            // return resp;
            window.open(resp, "_blank");
        }
    }


    return (
        <div className="col-12">
            <article className={`order-card ${order.category === "Dept" ? "dept-specific" : ""}`} >
                <div className="d-flex oc-row">
                    <div className="oc-stub d-none d-md-flex">
                        <span className="punch top" />
                        <span className="punch bot" />
                        <span className="dd">{date[0]}</span>
                        <span className="dm">
                            {new Date(`${date[2]}-${date[1]}-${date[0]}`).toLocaleString("en-US", { month: "short" }).toUpperCase()}
                        </span>
                        <span className="dy">{date[2]}</span>
                    </div>
                    <div className="oc-body">
                        <div className="d-flex gap-2 flex-wrap align-items-center mb-2">
                            {order.issuedby === "Finance" && order.category && (
                                <span className="badge-po general">
                                    {order.category}
                                </span>
                            )}
                            <span className="badge-po src d-none d-sm-inline">
                                {order.deptDesc}
                            </span>
                            <span className="order-no-pill" dangerouslySetInnerHTML={{ __html: highlight(order.goNo, q), }} />
                        </div>
                        <div
                            className="order-title"
                            dangerouslySetInnerHTML={{
                                __html: highlight(capitalizeFirstLetter(order.goDesc), q),
                            }}
                        />                        {/* <div className="order-title">
                            Issued By:{" "}
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: highlight(order.issuedby, q)
                                }}
                            />
                        </div> */}
                        <div class="order-meta d-flex flex-wrap gap-2 column-gap-4 mt-3 pt-3">
                            <span>Issued by:{" "} <b dangerouslySetInnerHTML={{
                                __html: highlight(order.issuedby, q)
                            }}></b></span>
                            {/* <span class="d-flex flex-wrap gap-1 align-items-center">Addressed to: <b>All Departments / Stakeholders</b></span> */}
                        </div>
                        <div className="mt-3">
                            <a
                                className="a-view"
                                href={order?.file}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => {
                                    e.preventDefault();
                                    getS3UrlDataPresidentialOrder(AWS_DOWNLOAD_URL_PO + order.file)
                                }}
                            >
                                <FileIcon /> View G.O {order.goType} {order.goNo}
                            </a>
                        </div>

                    </div>
                </div>
            </article>
        </div>
    );
}
/* ---------------- Main export ---------------- */
export default function PO2025Repository() {
    const [orders, setOrders] = useState([]);
    const [tab, setTab] = useState("all");
    const [query, setQuery] = useState("");
    const [user, setUser] = useState(null);
    const [loginOpen, setLoginOpen] = useState(false);
    const [uploadOpen, setUploadOpen] = useState(false);
    const [toast, setToast] = useState("");
    const [gos, setGos] = useState({})
    const tabRefs = useRef({});
    const [glider, setGlider] = useState({ left: 0, width: 0 });
    useEffect(() => {
        CommonAjaxGetRequestWithOutParamsWithoutToken(
            HRMS_API_BASE_URL + "po2025-go-details/report"
        ).then(res => {
            if (res) {
                setGos(res);
            }
        });
    }, []);
    const displayOrders = useMemo(() => {


        let list = [];

        if (tab === "general") {
            list = gos?.data?.gadGos || [];
        }
        else if (tab === "specific") {
            list = gos?.data?.financeGos || [];
        }
        else {
            list = gos?.data?.all || [];
        }

        if (query.trim()) {
            const search = query.toLowerCase();

            list = list.filter(item =>
                `${item.goNo || ""} 
             ${item.goDesc || ""} 
             ${item.deptDesc || ""} 
             ${item.deptCode || ""}`
                    .toLowerCase()
                    .includes(search)
            );
        }

        return list;

    }, [gos, tab, query]);
    
    useEffect(() => {
        const moveGlider = () => {
            const el = tabRefs.current[tab];
            if (el) setGlider({ left: el.offsetLeft, width: el.offsetWidth });
        };
        moveGlider();
        window.addEventListener("resize", moveGlider);
        return () => window.removeEventListener("resize", moveGlider);
    }, [tab]);

    function showToast(msg) {
        setToast(msg);
        window.clearTimeout(showToast._t);
        showToast._t = window.setTimeout(() => setToast(""), 2600);
    }
    const stTotal = orders.length;
    const stGen = orders.filter((o) => o.scope === "general").length;
    const stDept = orders.filter((o) => o.scope === "specific").length;
    const stCov = new Set(orders.flatMap((o) => o.depts || [])).size;
    function handleLogin(role) {
        setUser(role);
        setLoginOpen(false);
        showToast("Signed in. You can now upload orders.");
    }
    function handleLogout() {
        setUser(null);
        showToast("Signed out.");
    }
    function issuingLabel() {
        return user === "GAD"
            ? { full: "General Administration Department (SPF&MC)", short: "General Administration Department" }
            : { full: "Finance Department (HR.I – Planning & Policy)", short: "Finance Department" };
    }
    function handleSubmitOrder(order) {
        setOrders((prev) => [...prev, order]);
        setUploadOpen(false);
        showToast("Order published to the repository.");
    }

    const TABS = [
        {
            id: "all",
            label: "All",
            count: gos?.data?.all?.length || 0
        },
        {
            id: "general",
            label: "GAD Go's",
            count: gos?.data?.gadGos?.length || 0
        },
        {
            id: "specific",
            label: "FINANCE Go's",
            count: gos?.data?.financeGos?.length || 0
        },
    ];

    return (<>
        <Header />
        <div className="po-wrap">
            {/* Admin bar */}
            {user && (
                <div className="admin-bar">
                    <div className="container-xl py-2 d-flex align-items-center gap-3 flex-wrap">
                        <span className="admin-avatar">{user === "GAD" ? "GA" : "FD"}</span>
                        <span> Signed in via NIDHI:{" "}
                            <b style={{ color: "var(--navy)" }}>
                                {user === "GAD" ? "General Administration Department" : "Finance Department"}
                            </b>
                        </span>
                        <span className="text-secondary small d-none d-md-inline">
                            {user === "GAD" ? "(SPF&MC) — Designated Uploader" : "(HR.I – Plg. & Policy) — Designated Uploader"}
                        </span>
                        <div className="ms-auto d-flex gap-2">
                            <button className="btn-mini upload d-inline-flex align-items-center gap-2" onClick={() => setUploadOpen(true)}>
                                <UploadIcon /> Upload Order
                            </button>
                            <button className="btn-mini out d-inline-flex align-items-center gap-2" onClick={handleLogout}>
                                <LogoutIcon /> Sign out
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Hero */}
            <section className="hero position-relative">
                <div className="container container-xl">
                    <div className="text-center">
                        <h1 className="fs-3 fs-lg-2 col-12 col-lg-9 mx-auto">
                            Rules, Orders &amp; Instructions on implementation of the Presidential Order, 2025
                        </h1>
                        <p className="hero-sub small mt-2 col-12 col-md-10 col-lg-8 mx-auto">
                            A single public repository of general instructions and department-specific orders issued by the
                            General Administration Department and the Finance Department for the organisation of local cadres and
                            allocation of cadre strength.
                        </p>
                    </div>
                    <div className="row mt-4 justify-content-center">
                        <div className="col-12 col-md-10 col-lg-8 col-xl-7 text-center">
                            <div className="searchbar" role="search">
                                <input type="text" placeholder="Search by G.O. number, subject, department…"
                                    aria-label="Search orders" value={query}
                                    onChange={(e) => setQuery(e.target.value)} />
                                <button className="search-go" title="Search" aria-label="Search">
                                    <SearchIcon />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Main */}
            <main className="pb-5">
                <div className="container-xl kpi-pull">
                    {/* KPI row */}
                    <div className="row g-3 mb-4">
                        <div className="col-6 col-lg-3">
                            <div className="kpi">
                                <div className="kpi-ico navy">
                                    <FilesIcon />
                                </div>
                                <div>
                                    <div className="kpi-num">
                                        {gos?.data?.all?.length || 0}
                                    </div>
                                    <div className="kpi-lbl">Total Orders &amp; Rules</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-lg-3">
                            <div className="kpi">
                                <div className="kpi-ico green">
                                    <GlobeIcon />
                                </div>
                                <div>
                                    <div className="kpi-num">{gos?.data?.totalCount?.generalcatcount}</div>
                                    <div className="kpi-lbl">General Instructions</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-lg-3">
                            <div className="kpi">
                                <div className="kpi-ico blue">
                                    <BuildingIcon />
                                </div>
                                <div>
                                    <div className="kpi-num">{gos?.data?.totalCount?.deptcatcount}</div>
                                    <div className="kpi-lbl">Department-Specific</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-lg-3">
                            <div className="kpi">
                                <div className="kpi-ico amber">
                                    <UsersIcon />
                                </div>
                                <div>
                                    <div className="kpi-num">{gos?.data?.totalCount?.deptcount}</div>
                                    <div className="kpi-lbl">Departments Covered</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Segmented tabs */}
                    <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 mb-4">
                        <div className="seg-tabs" role="tablist">
                            <span className="seg-glider" style={{ left: glider.left, width: glider.width }} />
                            {TABS.map((tb) => (
                                <button key={tb.id} ref={(el) => (tabRefs.current[tb.id] = el)}
                                    className={`seg-tab ${tab === tb.id ? "active" : ""}`}
                                    onClick={() => setTab(tb.id)} >
                                    <span>{tb.label}</span>
                                    <span className="seg-badge">{tb.count}</span>
                                </button>
                            ))}
                        </div>
                        <span className="result-count">
                            <strong>{displayOrders.length}</strong> Government Orders Available
                        </span>
                    </div>

                    {/* Order list */}
                    <div className="row g-3 g-lg-4">
                        {displayOrders.length === 0 ? (
                            <div className="col-12">
                                <div className="empty-box text-center py-5 px-3">
                                    <div className="empty-ico mb-3">
                                        <InboxIcon />
                                    </div>
                                    <h3 className="fs-6 fw-bold mb-1">No orders found</h3>
                                    <p className="small text-secondary mb-0">Try a different keyword, or clear the department filter.</p>
                                </div>
                            </div>
                        ) : (
                            displayOrders.map((o, i) => (
                                <OrderCard
                                    key={`${o.id}-${i}`}
                                    order={o}
                                    q={query.trim().toLowerCase()}
                                    index={i}
                                />
                            ))
                        )}
                    </div>
                </div>
            </main>
            <div className={`toast-po ${toast ? "show" : ""}`}>{toast}</div>
        </div>
        <Footer />
    </>
    );
}
